import { render } from "./bid-deadline.vue?vue&type=template&id=4cacfc67"
import script from "./bid-deadline.vue?vue&type=script&lang=ts"
export * from "./bid-deadline.vue?vue&type=script&lang=ts"
script.render = render

export default script